// spacerPlugin.js
export default function (md) {
  // Inline rule: [spacer|100]
  function spacerInline(state, silent) {
    const pos = state.pos;
    const src = state.src;

    if (src.charCodeAt(pos) !== 0x5B /* [ */) return false;
    if (src.slice(pos, pos + 7) !== "[spacer") return false;

    const end = src.indexOf("]", pos);
    if (end === -1) return false;

    const inside = src.slice(pos + 1, end); // spacer|100
    const m = inside.match(/^spacer\|(\d{1,5})$/);
    if (!m) return false;

    const height = Number(m[1]);
    if (!Number.isFinite(height) || height < 0) return false;

    if (silent) return true;

    const token = state.push("spacer", "", 0);
    token.meta = { height };
    token.attrs = [["height", Number(height)]];

    state.pos = end + 1;
    return true;
  }

  md.inline.ruler.before("link", "spacer_inline", spacerInline);
}
